import api from "./api";
import {
  CertificateTemplateDetail,
  CertificateTemplateListResponse,
  CertificateTemplatePayload,
  CertificateTemplateVariablesResponse,
} from "../types/CertificateTemplate";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token nao encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export async function findAllCertificateTemplates(
  currentPage: number,
  perPage: number,
): Promise<CertificateTemplateListResponse> {
  const response = await api.get<CertificateTemplateListResponse>("/certificate-templates", {
    params: {
      page: currentPage,
      per_page: perPage,
    },
    headers: getAuthHeaders(),
  });

  return response.data;
}

export async function findCertificateTemplate(
  templateId: string | number,
): Promise<CertificateTemplateDetail> {
  const response = await api.get<CertificateTemplateDetail>(
    `/certificate-templates/${templateId}`,
    {
      headers: getAuthHeaders(),
    },
  );

  return response.data;
}

export async function createCertificateTemplate(
  payload: CertificateTemplatePayload,
): Promise<void> {
  await api.post("/certificate-templates", payload, {
    headers: getAuthHeaders(),
  });
}

export async function updateCertificateTemplate(
  templateId: string | number,
  payload: CertificateTemplatePayload,
): Promise<void> {
  await api.put(`/certificate-templates/${templateId}`, payload, {
    headers: getAuthHeaders(),
  });
}

export async function deleteCertificateTemplate(
  templateId: string | number,
): Promise<void> {
  await api.delete(`/certificate-templates/${templateId}`, {
    headers: getAuthHeaders(),
  });
}

export async function duplicateCertificateTemplate(
  templateId: string | number,
): Promise<CertificateTemplateDetail> {
  const response = await api.post<CertificateTemplateDetail>(
    `/certificate-templates/${templateId}/duplicate`,
    {},
    {
      headers: getAuthHeaders(),
    },
  );

  return response.data;
}

export async function findCertificateTemplateVariables(): Promise<CertificateTemplateVariablesResponse> {
  const response = await api.get<CertificateTemplateVariablesResponse>(
    "/certificate-templates/variables",
    {
      headers: getAuthHeaders(),
    },
  );

  return response.data;
}
